<script lang="ts" setup>
const cursorData = reactive({
  x: '0px',
  y: '0px'
});

const cursorLightShow = ref(false);

const handleMousemove = (e: any) => {
  cursorData.y = e.clientX + 'px';
  cursorData.x = e.clientY + 'px';
};

const isShow = ref(false);
onMounted(() => {
  document.addEventListener('mousemove', handleMousemove);
  cursorData.x = window.innerWidth / 2 + 'px';
  cursorData.y = window.innerHeight + 'px';
  cursorLightShow.value = true;

  setTimeout(() => {
    isShow.value = true;
  }, 500);
});
</script>

<template>
  <section class="section" :class="{ isShow }">
    <figure class="section__bg">
      <Nimg src="./images/membership/main.jpg" />
    </figure>
    <div class="section__mobileText">
      我們協助每個熱愛生活的人，尋找生活中的亮點，體驗挑戰每一個精彩的時刻。
      <br />
      完成恆隆行會員註冊並通過身份驗證，即可加入「生活有亮點計劃」享受會員專屬服務。
      <br />
      Let's be Sparkling，閃亮自己豐盛生活！
    </div>
    <div class="section__slogan">
      <div class="section__slogan__mobile">
        <Nimg src="./images/lifeText1White.svg" class="lifeText1" format="" />
        <Nimg src="./images/lifeText2White.svg" class="lifeText2" format="" />
        <Nimg src="./images/lifeText3White.svg" class="lifeText3" format="" />
        <Nimg src="./images/lifeText4White.svg" class="lifeText4" format="" />
        <Nimg src="./images/lifeText5White.svg" class="lifeText5" format="" />
        <Nimg src="./images/lifeText6White.svg" class="lifeText6" format="" />
        <Nimg src="./images/lifeText7White.svg" class="lifeText7" format="" />
      </div>
      <div class="section__slogan__left">
        <Nimg src="./images/lifeText1White.svg" class="lifeText1" format="" />
        <Nimg src="./images/lifeText2White.svg" class="lifeText2" format="" />
        <Nimg src="./images/lifeText3White.svg" class="lifeText3" format="" />
        <Nimg src="./images/lifeText4White.svg" class="lifeText4" format="" />
        <Nimg src="./images/lifeText5White.svg" class="lifeText5" format="" />
        <div class="section__slogan__by">
          <svg xmlns="http://www.w3.org/2000/svg" width="191" height="30" viewBox="0 0 191 30" fill="none">
            <path
              d="M0.0178849 22.5116V0H3.02421V9.09055H3.18527C3.18527 9.09055 3.25684 8.9116 3.32841 8.80423C3.39999 8.69686 3.57894 8.48213 3.84736 8.19581C4.11579 7.8916 4.42 7.64107 4.79579 7.40844C5.17158 7.17581 5.67264 6.97897 6.31685 6.80002C6.97896 6.62107 7.69474 6.5137 8.46422 6.5137C10.5042 6.5137 12.2042 7.28318 13.6 8.80423C14.9958 10.3253 15.6758 12.2937 15.6758 14.6916C15.6758 17.0895 14.9779 19.1295 13.6 20.6327C12.2042 22.1358 10.4684 22.8874 8.39264 22.8874C7.56948 22.8874 6.8179 22.7801 6.10211 22.5832C5.38632 22.3864 4.84947 22.1358 4.4379 21.8316C4.02632 21.5274 3.70421 21.2411 3.41789 20.9369C3.13158 20.6327 2.95263 20.4 2.84526 20.1853L2.64842 19.8811H2.54105L2.12947 22.4758H0L0.0178849 22.5116ZM4.29473 10.5937C3.34631 11.6137 2.88105 12.9916 2.88105 14.7095C2.88105 16.4274 3.34631 17.7874 4.29473 18.8253C5.24316 19.8453 6.40632 20.3643 7.80211 20.3643C9.1979 20.3643 10.3253 19.8274 11.2379 18.7716C12.1505 17.6979 12.5979 16.3558 12.5979 14.7095C12.5979 13.0632 12.1505 11.6853 11.2379 10.6295C10.3253 9.57371 9.18 9.05476 7.80211 9.05476C6.42421 9.05476 5.24316 9.55581 4.29473 10.5937Z"
              fill="white" />
            <path
              d="M30.5058 6.8905H33.5122V21.9937C33.5122 24.159 32.8858 25.8769 31.6332 27.2011C30.3806 28.5074 28.5732 29.1695 26.2111 29.1695C23.4195 29.1695 21.3437 28.3642 19.9479 26.7537L21.5584 24.7853L21.7016 24.9105C21.809 25.0179 21.9163 25.1074 22.0416 25.2326C22.1669 25.34 22.3279 25.4653 22.5248 25.6084C22.7216 25.7516 22.9542 25.8769 23.1869 26.0021C23.4374 26.1274 23.7058 26.2348 23.9921 26.36C24.2785 26.4674 24.6006 26.5569 24.9764 26.6105C25.3521 26.6642 25.7458 26.7179 26.1395 26.7179C29.0385 26.7179 30.4879 25.179 30.4879 22.1011V20.9021C29.3964 22.2442 27.8216 22.9063 25.7458 22.9063C23.67 22.9063 21.9879 22.2621 20.8427 20.9737C19.6974 19.6853 19.1248 17.9495 19.1248 15.7663V6.90839H22.1848V15.4621C22.1848 16.9116 22.5069 18.0747 23.1869 18.9874C23.8669 19.9 24.8511 20.3474 26.1753 20.3474C27.4995 20.3474 28.5553 19.9179 29.289 19.0589C30.0406 18.2 30.4343 17.2516 30.4879 16.2137V6.92629L30.5058 6.8905Z"
              fill="white" />
            <path
              d="M48.8192 22.5116V0H51.8613V8.37475H51.9866C53.0424 7.14001 54.6529 6.5137 56.8182 6.5137C58.8045 6.5137 60.3792 7.15791 61.5245 8.46423C62.6698 9.77055 63.2603 11.4884 63.2603 13.6179V22.5116H60.2182V13.9937C60.2182 12.5621 59.8603 11.3811 59.1445 10.4505C58.4108 9.53791 57.4087 9.07266 56.1203 9.07266C54.8318 9.07266 53.7761 9.50213 53.0424 10.379C52.3087 11.2558 51.915 12.2042 51.8792 13.2242V22.4937H48.8371L48.8192 22.5116Z"
              fill="white" />
            <path
              d="M79.3256 18.9699L80.4351 21.0994C80.3098 21.2246 80.113 21.3857 79.8624 21.6004C79.6119 21.8152 78.9856 22.0836 78.0193 22.4236C77.053 22.7636 75.9793 22.9246 74.8161 22.9246C72.3645 22.9246 70.414 22.1731 68.9645 20.6699C67.515 19.1667 66.7814 17.1804 66.7814 14.7288C66.7814 12.2773 67.4614 10.3804 68.8393 8.84146C70.1993 7.28461 72.0066 6.51514 74.2256 6.51514C76.4445 6.51514 78.1446 7.24882 79.3793 8.69829C80.614 10.1478 81.2225 12.0088 81.2225 14.2994V15.0867H69.8056C69.8951 16.8225 70.3961 18.1467 71.3445 19.0415C72.293 19.9362 73.5098 20.4015 75.0308 20.4015C75.854 20.4015 76.6235 20.2762 77.3393 20.0436C78.073 19.8109 78.574 19.5604 78.914 19.3099L79.3614 18.9699H79.3256ZM74.1898 9.00251C71.8098 9.00251 70.3961 10.273 69.9487 12.832H78.1803C77.8224 10.273 76.4982 9.00251 74.2077 9.00251H74.1898Z"
              fill="white" />
            <path
              d="M84.8492 22.5131V6.89093H86.9071L87.2471 9.16356H87.4797C88.6071 7.40987 90.3966 6.51514 92.8303 6.51514C94.8345 6.51514 96.4271 7.15934 97.5724 8.44777C98.7177 9.73619 99.3082 11.4541 99.3082 13.6194V22.5131H96.284V13.9594C96.284 12.5278 95.9261 11.3467 95.1924 10.4341C94.4587 9.53935 93.4387 9.07409 92.1324 9.07409C90.8261 9.07409 89.7882 9.50356 89.0545 10.3625C88.3208 11.2394 87.945 12.1699 87.9271 13.1899V22.4952H84.8671L84.8492 22.5131Z"
              fill="white" />
            <path
              d="M118.524 6.89005V21.4743C118.524 23.7827 117.862 25.6438 116.538 27.0575C115.214 28.4711 113.335 29.1869 110.901 29.1869C108.128 29.1869 106.034 28.3817 104.656 26.7711L106.267 24.8027C107.519 26.0732 109.058 26.6996 110.83 26.6996C113.961 26.6996 115.518 24.9817 115.518 21.5638V20.3469H115.375C115.375 20.3469 115.303 20.508 115.214 20.6332C115.142 20.7406 114.963 20.9553 114.695 21.2417C114.427 21.5459 114.104 21.7964 113.747 22.029C113.389 22.2438 112.888 22.4585 112.243 22.6375C111.599 22.8343 110.883 22.9238 110.114 22.9238C108.02 22.9238 106.302 22.1543 104.924 20.6332C103.547 19.0943 102.849 17.1438 102.849 14.728C102.849 12.3122 103.547 10.2901 104.942 8.80479C106.338 7.30163 108.074 6.55005 110.185 6.55005C111.009 6.55005 111.76 6.65742 112.44 6.85426C113.12 7.05111 113.657 7.30163 114.051 7.60584C114.444 7.91005 114.802 8.19637 115.071 8.50058C115.357 8.80479 115.554 9.03743 115.679 9.25216L115.822 9.55637H115.983L116.395 6.96163H118.524V6.89005ZM114.283 18.808C115.232 17.7701 115.697 16.4101 115.697 14.6922C115.697 12.9743 115.232 11.6143 114.283 10.5764C113.335 9.53848 112.154 9.03743 110.74 9.03743C109.327 9.03743 108.199 9.55638 107.269 10.6301C106.356 11.7037 105.891 13.0459 105.891 14.6922C105.891 16.3385 106.338 17.7164 107.269 18.7722C108.199 19.828 109.344 20.3469 110.74 20.3469C112.136 20.3469 113.335 19.828 114.283 18.808Z"
              fill="white" />
            <path
              d="M122.265 20.9904L123.482 18.8967C124.931 19.9167 126.667 20.4177 128.725 20.4177C130.908 20.4177 132 19.7198 132 18.324C132 17.7335 131.66 17.2504 130.998 16.8746C130.336 16.4988 129.512 16.2125 128.564 15.9619C127.598 15.7293 126.667 15.443 125.719 15.1209C124.77 14.7988 123.965 14.2977 123.303 13.5998C122.641 12.9019 122.301 12.043 122.301 11.0051C122.301 9.69877 122.802 8.60719 123.804 7.76613C124.806 6.92508 126.273 6.49561 128.188 6.49561C129.405 6.49561 130.532 6.62087 131.588 6.83561C132.644 7.06824 133.396 7.26508 133.843 7.46192L134.505 7.80192L133.396 10.2535C132.089 9.37667 130.443 8.94719 128.474 8.94719C126.291 8.94719 125.2 9.6093 125.2 10.9156C125.2 11.4525 125.54 11.8998 126.202 12.2577C126.864 12.5977 127.687 12.884 128.635 13.0988C129.584 13.3135 130.532 13.564 131.499 13.8861C132.447 14.1904 133.27 14.7093 133.932 15.4251C134.594 16.1588 134.934 17.0714 134.934 18.1809C134.934 19.5409 134.433 20.6683 133.413 21.5451C132.393 22.422 130.837 22.8693 128.725 22.8693C127.884 22.8693 127.079 22.7977 126.327 22.6546C125.575 22.5114 124.949 22.3683 124.484 22.1714C124.019 21.9925 123.589 21.8135 123.249 21.6346C122.891 21.4556 122.641 21.2946 122.48 21.1514L122.247 20.9725L122.265 20.9904Z"
              fill="white" />
            <path
              d="M136.833 6.89033H139.696V2.11243H142.738V6.89033H147.212V9.30613H142.738V17.9314C142.738 19.5061 143.472 20.2756 144.904 20.2756C145.226 20.2756 145.566 20.2219 145.924 20.0967C146.282 19.9893 146.568 19.864 146.765 19.7388L147.069 19.5956L147.999 21.7609C147.892 21.8683 147.713 21.9935 147.463 22.1367C147.212 22.2798 146.801 22.4409 146.228 22.6198C145.655 22.7988 145.083 22.8883 144.474 22.8883C142.864 22.8883 141.665 22.4588 140.877 21.5819C140.09 20.723 139.714 19.5061 139.714 17.9672V9.30613H136.851V6.89033H136.833Z"
              fill="white" />
            <path
              d="M161.788 6.8905H164.813V21.9937C164.813 24.159 164.186 25.8769 162.934 27.2011C161.681 28.5253 159.874 29.1695 157.512 29.1695C154.738 29.1695 152.644 28.3642 151.266 26.7537L152.859 24.7853L153.02 24.9105C153.127 25.0179 153.235 25.1074 153.36 25.2326C153.485 25.34 153.646 25.4653 153.843 25.6084C154.04 25.7516 154.255 25.8769 154.505 26.0021C154.756 26.1274 155.024 26.2348 155.31 26.36C155.597 26.4674 155.919 26.5569 156.295 26.6105C156.671 26.6642 157.046 26.7179 157.44 26.7179C160.339 26.7179 161.788 25.179 161.788 22.1011V20.9021C160.697 22.2442 159.122 22.9063 157.064 22.9063C155.006 22.9063 153.288 22.2621 152.143 20.9737C150.998 19.6853 150.443 17.9495 150.443 15.7663V6.90839H153.485V15.4621C153.485 16.9116 153.825 18.0747 154.487 18.9874C155.149 19.9 156.152 20.3474 157.458 20.3474C158.764 20.3474 159.838 19.9179 160.589 19.0589C161.341 18.2 161.735 17.2516 161.771 16.2137V6.92629L161.788 6.8905Z"
              fill="white" />
            <path d="M169.636 22.5116V0H172.696V22.5116H169.636Z" fill="white" />
            <path
              d="M189.101 18.9699L190.21 21.0994C190.085 21.2246 189.888 21.3857 189.637 21.6004C189.387 21.8152 188.761 22.0836 187.794 22.4236C186.828 22.7636 185.754 22.9246 184.591 22.9246C182.139 22.9246 180.189 22.1731 178.739 20.6699C177.29 19.1667 176.556 17.1804 176.556 14.7288C176.556 12.2773 177.236 10.3804 178.614 8.84146C179.974 7.28461 181.782 6.51514 184 6.51514C186.219 6.51514 187.919 7.24882 189.154 8.69829C190.389 10.1478 190.997 12.0088 190.997 14.2994V15.0867H179.58C179.67 16.8225 180.171 18.1467 181.119 19.0415C182.068 19.9541 183.285 20.4015 184.806 20.4015C185.629 20.4015 186.398 20.2762 187.114 20.0436C187.848 19.8109 188.349 19.5604 188.689 19.3099L189.136 18.9699H189.101ZM183.965 9.00251C181.585 9.00251 180.171 10.273 179.724 12.832H187.955C187.597 10.273 186.273 9.00251 183.983 9.00251H183.965Z"
              fill="white" />
          </svg>
        </div>
      </div>
      <div class="section__slogan__center">
        我們協助每個熱愛生活的人，尋找生活中的亮點，體驗挑戰每一個精彩的時刻。
        <br />
        完成恆隆行會員註冊並通過身份驗證，即可加入「生活有亮點計劃」享受會員專屬服務。
        <br />
        Let's be Sparkling，閃亮自己豐盛生活！
      </div>
      <div class="section__slogan__right">
        <Nimg src="./images/lifeText6White.svg" class="lifeText6" format="" />
        <Nimg src="./images/lifeText7White.svg" class="lifeText7" format="" />
      </div>
    </div>

    <div class="cursorLight" :class="{ isShow: cursorLightShow }" :style="{ top: cursorData.x, left: cursorData.y }">
    </div>
  </section>
</template>

<style lang="scss" scoped>
.cursorLight {
  position: absolute;
  z-index: 10;
  width: 80vw;
  height: 80vw;
  margin: -40vw 0 0 -40vw;
  border-radius: 50%;
  background: radial-gradient(50% 50% at 50% 50%, rgba(225, 255, 255, 0.6) 0%, rgba(225, 255, 255, 0) 83.85%);
  filter: blur(50px);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.5s;

  &.isShow {
    opacity: 1;
  }

  @include max-media(990) {
    display: none;
  }
}

.section {
  position: relative;
  width: 100%;
  height: 100vh;
  margin-top: toRem(-154);

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
    width: 100%;
    height: 100%;
    background-color: $color-brand-3;
    transition: all 1.2s ease-in-out;
  }

  &__bg {
    position: absolute;
    left: 0;
    top: 0;
    z-index: -1;
    width: 100%;
    height: 100%;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.3);
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__mobileText {
    position: absolute;
    left: 50%;
    top: toRem(190);
    z-index: 5;
    transform: translateX(-50%);
    width: 100%;
    max-width: toRem(240);
    text-align: center;
    font-size: toRem(14);
    line-height: 1.6;
    color: $color-white-1;

    @include min-media(991) {
      display: none;
    }
  }

  &__slogan {
    position: absolute;
    left: 0;
    bottom: toRem(105);
    z-index: 20;
    z-index: 1000;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 8vw;

    @include max-media(640) {
      height: 10vw;
    }

    img {
      height: 100%;
    }

    &__mobile {
      display: flex;
      align-items: center;
      justify-content: center;

      @include min-media(991) {
        display: none;
      }
    }

    &__left,
    &__right {
      position: relative;
      display: flex;
      transition: all 1.5s cubic-bezier(0.87, 0, 0.13, 1);

      @include max-media(990) {
        display: none;
      }
    }

    &__left {
      @include min-media(991) {
        width: 44%;
      }
    }

    &__right {
      @include min-media(991) {
        width: 17%;
      }
    }

    &__center {
      position: absolute;
      left: 50%;
      transform: translateX(0%);
      width: 25vw;
      font-size: toRem(16);
      font-size: 1.1vw;
      font-weight: 500;
      line-height: 1.6;
      text-align: center;
      color: $color-white-1;
      opacity: 0;
      transition: all 1s ease-in-out;
    }

    &__by {
      position: absolute;
      left: 0;
      bottom: toRem(-70);
      opacity: 0;
      transition: all 1s ease-in-out;
    }
  }

  .lifeText1 {
    margin-right: toRem(20);
  }

  .lifeText2 {
    margin-right: toRem(18);
  }

  .lifeText3 {
    margin-right: toRem(10);
  }

  .lifeText4 {
    @include max-media(990) {
      margin-right: toRem(10);
    }
  }

  .lifeText5 {
    @include max-media(990) {
      margin-right: toRem(10);
    }
  }

  .lifeText6 {
    margin-right: toRem(14);
  }

  &.isShow {
    z-index: 0;

    &::before {
      opacity: 0;
    }

    @include min-media(991) {
      .section {
        &__slogan {
          &__left {
            transform: translateX(-39%);
          }

          &__right {
            transform: translateX(104%);
          }

          &__center {
            opacity: 1;
            transition-delay: 1s;
          }

          &__by {
            opacity: 1;
            transition-delay: 1.5s;
          }
        }
      }
    }
  }
}
</style>
